import classNames from "classnames";
import React from "react";
import { deepEqual } from "../deep-equal";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { AppCard, AppCardContent } from "./Generic/AppCard";
import QuestionHeader from "./QuestionHeader";
import RequiredDocReadonlyAnswer from "./RequiredDocReadonlyAnswer";
import { ReqDocAnswerableQuestionMulti } from "./ScheduledVisitDocScreen";
import { scrollToViewAfterKeyboardOpen } from "./ScheduledVisitDocScreenUtils";
import { RequiredDocAutocompleteCheck } from "./RequiredDocAutocompleteCheck";

/**
 * COPIED FROM ScheduledVisitDocScreen
 */

const MAX_POSSIBILLITIES_TO_REGULAR_CHECKBOXES = 20;

export interface RequiredDocCheckState {
  otherVal: string;
  otherChecked: boolean;
  hash: string;
}

export class RequiredDocCheck extends React.Component<
  ReqDocAnswerableQuestionMulti,
  RequiredDocCheckState
> {
  constructor(props: ReqDocAnswerableQuestionMulti) {
    super(props);
    const randomHash = Math.random().toString(36).substring(7);
    this.state = {
      otherVal: "",
      otherChecked: false,
      hash: randomHash,
    };
  }

  componentDidMount() {
    this.checkForOther();
  }

  shouldComponentUpdate(nextProps: any, nextState: any) {
    return !deepEqual(nextProps, this.props) || !deepEqual(nextState, this.state);
  }

  toggleOtherCheck(value: string, checked: boolean) {
    this.setState({
      ...this.state,
      otherChecked: checked,
    });
    this.handleCheck(value, checked);
  }
  removeFromAnswers(value: string) {
    return (this.props.currentAnswer as string[]).filter((val) => val !== value);
  }

  addToAnswers(value: string) {
    return !this.inAnswers(value)
      ? (this.props.currentAnswer as string[]).concat(value)
      : [...(this.props.currentAnswer as string[])];
  }

  inAnswers(value: string) {
    return (this.props.currentAnswer as string[]).indexOf(value) !== -1;
  }

  checkForOther() {
    for (const answer of this.props.currentAnswer as string[]) {
      if (this.props.possibleAnswers.indexOf(answer) === -1) {
        this.setState({
          otherVal: answer,
          otherChecked: true,
        });
        return;
      }
    }
  }

  handleCheck(value: string, checked: boolean) {
    const newAnswers = checked ? this.addToAnswers(value) : this.removeFromAnswers(value);
    this.props.handleOnInsertAnswer(this.props.questionId, newAnswers);
  }
  changeOtherVal(value: string) {
    const newVals = this.removeFromAnswers(this.state.otherVal);

    if (newVals.indexOf(value) === -1) {
      newVals.push(value);
    }

    this.setState({
      ...this.state,
      otherVal: value,
    });

    this.props.handleOnInsertAnswer(this.props.questionId, newVals);
  }

  renderOtherOptions() {
    const status = this.state.otherChecked;
    return (
      <AppCard>
        <AppCardContent
          key={this.props.possibleAnswers.length}
          className="ScheduledVisitDocScreen__checkBox checkbox checkbox--material"
        >
          <input
            type="checkbox"
            disabled={this.props.readonly}
            name={`${this.props.questionId}${this.state.hash}`}
            className="checkbox__input checkbox--material__input"
            checked={status}
            onChange={(event: any) =>
              this.toggleOtherCheck(this.state.otherVal, event.target.checked)
            }
          />
          <div className="checkbox__checkmark checkbox--material__checkmark" />
          {translate(STRINGS.OTHER)}
        </AppCardContent>
        {status ? (
          <AppCardContent onClick={(e) => scrollToViewAfterKeyboardOpen(e)}>
            <input
              placeholder={translate(STRINGS.ENTER_TEXT_HERE)}
              className="ScheduledVisitDocScreen__block text-input text-input--material"
              disabled={this.props.readonly}
              onChange={(event: any) => {
                this.changeOtherVal(event.target.value);
              }}
              value={this.state.otherVal}
            />
          </AppCardContent>
        ) : null}
      </AppCard>
    );
  }

  handleAppCardClick() {
    if (this.props.readonly && this.props.onClickWhileDisabled !== undefined) {
      this.props.onClickWhileDisabled();
    }
  }

  renderRegularCheck() {
    return this.props.possibleAnswers.map((val, index) => {
      const status = (this.props.currentAnswer as string[]).indexOf(val) !== -1;
      return (
        <div
          key={index}
          className="ScheduledVisitDocScreen__checkBox checkbox checkbox--material"
          onClick={() => this.handleCheck(val, !status)}
        >
          <input
            disabled={this.props.readonly}
            name={`${this.props.questionId}${this.state.hash}`}
            type="checkbox"
            className="checkbox__input checkbox--material__input"
            defaultChecked={status}
            onChange={(event: any) => this.handleCheck(val, event.target.checked)}
          />
          <div className="checkbox__checkmark checkbox--material__checkmark" />
          {val}
        </div>
      );
    });
  }

  render() {
    return (
      <AppCard
        className={classNames({ __invalid: !this.props.isValid })}
        onClick={() => this.handleAppCardClick()}
      >
        <QuestionHeader
          text={this.props.questionText}
          isRequired={this.props.isRequired}
          notes={this.props.notes}
          isReadonly={this.props.readonly}
        />
        <AppCardContent>
          {this.props.readonly ? (
            <RequiredDocReadonlyAnswer currentAnswer={this.props.currentAnswer} />
          ) : (
            <>
              {this.props.possibleAnswers.length >= MAX_POSSIBILLITIES_TO_REGULAR_CHECKBOXES ? (
                <RequiredDocAutocompleteCheck
                  possibleAnswers={this.props.possibleAnswers}
                  currentAnswer={this.props.currentAnswer}
                  readonly={this.props.readonly}
                  handleCheck={this.handleCheck.bind(this)}
                  inAnswer={this.inAnswers.bind(this)}
                />
              ) : (
                this.renderRegularCheck()
              )}
              {this.props.showOtherOption ? this.renderOtherOptions() : null}
            </>
          )}
        </AppCardContent>
      </AppCard>
    );
  }
}
